// This file is auto-generated by ./bin/rails view_component:stimulus_manifest:update
// Run that command whenever you add a new controller in ViewComponent

import { application } from "../javascript/controllers/application"

// import CollectionFilter__ComponentController from "./collection_filter/component_controller"
// application.register("collection-filter--component", CollectionFilter__ComponentController)

// import CollectionFilter__ListComponentController from "./collection_filter/list_component_controller"
// application.register("collection-filter--list-component", CollectionFilter__ListComponentController)

// import CollectionPager__ComponentController from "./collection_pager/component_controller"
// application.register("collection-pager--component", CollectionPager__ComponentController)

import Modal__ComponentController from "./modal/component_controller"
application.register("modal--component", Modal__ComponentController)

// import Dropdown__ComponentController from "./resource_form/dropdown_component_controller"
// application.register("resource-form--dropdown-component", Dropdown__ComponentController)

// import ResourceForm__ComponentController from "./resource_form/component_controller"
// application.register("resource-form--component", ResourceForm__ComponentController)

import Notification__ComponentController from "./notification/component_controller"
application.register("notification--component", Notification__ComponentController)
